import * as React from 'react';
import Slider from 'react-slick';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { isNull, getContentFronStorage } from '../utils/index';
import { CMS } from '../shared/index';
import { newI18n } from '../core/Const';

export interface Homesection5Props extends BaseComponentProps {
	lang: string;
}
export interface Homesection5State extends BaseComponentState {
	slider: any[];
}
export class Homesection5 extends BaseComponent<Homesection5Props, Homesection5State> {

	translation = {
		Title: newI18n("HOME.OURTEAM.Title", "Our Bali Team "),
		SubTitle: newI18n("HOME.OURTEAM.SubTitle", " "),
	};

	constructor(props: Homesection5Props) {
		super(props);
		this.state = {
			slider : []
		};
		this.getData();
	}

	componentDidUpdate(prevProps: Homesection5Props, prevState: Homesection5State) {
		if (prevProps.lang !== this.props.lang) {
			this.getData();
		}
	} 

	getData: () => any = () => {
		getContentFronStorage(this.props.lang, "CmsWithLocal").then(
			(d: any[]) => {
				if (!isNull(d)) {
					let rows: CMS.CmsWithLocal[] = d;
	
					let slide: any[] = [];
					for (let a of rows) {
						slide.push(this.createSlider(a, 'slide_' + a.code));
					}
	
					this.setStateHelper(st => {
						st.slider = slide;
					});
				}
			}).catch((exc) => { console.error('error: ', exc); });
		 
	}

	createSlider(data: CMS.CmsWithLocal, key: string) {

		return (
			<div key={key}>
				<div className="padding-10">
					<div className="thumb icons-effect margin-bottom-15">
						<img alt="" src={data.image} className="img-responsive" style={{ borderRadius: '50%' }} />
						<div className="mask team">
							<div className="icons-wrapper">
								<div className="icons"/> 
							</div>
						</div>
					</div>
					<h4>{data.name}</h4>
					<p style={{textAlign: 'center'}}>{isNull(data.position) ? '' : data.position}</p>
				</div>
			</div>
		);
	}

	render() {
		if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
		var settings = {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 7,
			slidesToScroll: 7,
			autoplay: true,
			responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 6,
					slidesToScroll: 6,
					infinite: true,
					dots: true
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: true
				}
			}, {
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					initialSlide: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};
		let slider = [];
		if (!isNull(this.state.slider)) {
			slider = this.state.slider;
		}
		return (
			<section className="container-fluid container-fullw " style={{ backgroundColor: '#334960' }}>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h2 className="text-center text-white" > {this.translation.Title}</h2>
							<hr />
							<h4 className="text-center text-white" > {this.translation.SubTitle}</h4>
							<div className="row team">
								<div data-appears-group-delay="0" data-appears-delay-increase="200">
									<Slider {...settings}>
										{slider}
									</Slider>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}
}



// WEBPACK FOOTER //
// ./src/home/Homesection5.tsx